import { E } from '@angular/cdk/keycodes';
import { ElementRef, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { NgxExtendedPdfViewerService } from 'src/app/pdf/ngx-extended-pdf-viewer';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class PdfHandlerService {
  constructor() {}

  async validateDateInput(dateString: string, label: string): Promise<boolean> {
    const datePattern =
      /^\d{4}\s(January|February|March|April|May|June|July|August|September|October|November|December)\s\d{1,2}$/;

    const today = new Date();
    const formattedToday = this.formatDate(today); // Format today's date
    if (!datePattern.test(dateString)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Date Format',
        text: `${label} should be in the format YYYY Month DD. For example: ${formattedToday}`,
        confirmButtonText: 'OK',
        customClass: {
          container: 'swal2-container'
        }
      });
      return false;
    }

    const isValidPreviousDate = await this.validatePreviousDate(
      dateString,
      label
    );
    if (!isValidPreviousDate) {
      return false;
    }

    return true;
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' }); // Full month name
    const day = date.getDate();
    return `${year} ${month} ${day}`;
  }

  async validatePreviousDate(
    dateString: string,
    label: string
  ): Promise<boolean> {
    const [year, monthName, day] = dateString.split(' ');
    const monthIndex = new Date(`${monthName} 1`).getMonth(); // Get the month index
    const inputDate = new Date(Number(year), monthIndex, Number(day)); // Valid Date object

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate < today) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Date',
        text: `${label} should not be a previous date.`,
        confirmButtonText: 'OK',
        customClass: {
          container: 'swal2-container'
        }
      });
      return false;
    }
    return true;
  }
}
